/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import {
    ReplenishmentCompleteViewModel,
    ReplenishmentsService,
} from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { ReplenishmentStore } from './replenishment.store';
import {
    ReplenishmentCreate,
    ReplenishmentRead,
    ReplenishmentSearchParams,
} from '../../entities/replenishment.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class ReplenishmentDataService extends AbstractDataService<
    ReplenishmentRead,
    ReplenishmentCreate
> {
    protected EntityName = PFWmsEntities.Replenishment;
    constructor(
        private service: ReplenishmentsService,
        store: ReplenishmentStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }

    protected createObs$(
        body: ReplenishmentCreate
    ): Observable<ReplenishmentRead> {
        return this.service.replenishmentCreate({
            replenishmentViewModelCreateBody: body,
        }) as Observable<ReplenishmentRead>;
    }

    protected deleteObs$(id: string): Observable<ReplenishmentRead> {
        return this.service.replenishmentDelete({
            id,
        }) as Observable<ReplenishmentRead>;
    }

    protected undoDeleteObs$(id: string): Observable<ReplenishmentRead> {
        return this.service.replenishmentUndoDelete({
            id,
        }) as Observable<ReplenishmentRead>;
    }

    protected getObs$(id: string): Observable<ReplenishmentRead> {
        return this.service.replenishmentReadById({
            id,
        }) as Observable<ReplenishmentRead>;
    }

    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<ReplenishmentRead> {
        return this.service.replenishmentUpdatePatch({
            id,
            operation: operations,
        }) as Observable<ReplenishmentRead>;
    }

    protected searchObs$(
        searchParams: ReplenishmentSearchParams
    ): Observable<IPagedResult<ReplenishmentRead>> {
        return this.service.replenishmentSearch(searchParams) as Observable<
            IPagedResult<ReplenishmentRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<ReplenishmentRead>>> {
        return this.service.replenishmentGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<ReplenishmentRead>>
        >;
    }

    claimReplenishments$(warehouseId: string, replenishmentIds: string[]) {
        return this.service.v1ReplenishmentsClaimPost({
            replenishmentClaimRequest: {
                warehouseId,
                replenishmentIds,
            },
        }) as Observable<ReplenishmentRead[]>;
    }

    unClaimReplenishments$(warehouseId: string, replenishmentIds: string[]) {
        return this.service.v1ReplenishmentsUnclaimPost({
            replenishmentUnclaimRequest: {
                warehouseId,
                replenishmentIds,
            },
        });
    }

    completeReplenishment$(
        id: string,
        replenishmentCompleteViewModel: ReplenishmentCompleteViewModel
    ) {
        return this.service.v1ReplenishmentsIdCompletePost({
            id,
            replenishmentCompleteViewModel,
        });
    }

    cancelReplenishment$(id: string) {
        return this.service.v1ReplenishmentsIdCancelPost({
            id,
        }) as Observable<ReplenishmentRead>;
    }
}
